// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { memo, useState } from "react";
import { useDispatch } from "react-redux";
import { RxCross1 } from "react-icons/rx";
import { logAmplitudeEvent } from "../../utils/amplitude/functions";
import amplitude from "../../utils/amplitude/initiate";
import { useSelector } from "react-redux";
import { userLogsAPI } from "../../services/session.service";
import { setCABannerActive, setIsHeaderPopActive } from "../../store/auth/action";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { handleItem } from "../../utils/handleItem";
import { getSession } from "../../utils/sessionstore";

function NewCABanner() {
    const {clientname, userDetails, subscriptions, activedashboard} = useSelector((state) => ({
        clientname: state.clientname,
        userDetails: state.userDetails,
        subscriptions: state.subscriptions,
        activedashboard: state.activedashboard
    }));
    const { clientID } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [msImageLoaded, setMSImageLoaded] = useState(false);
    const [etImageLoaded, setETImageLoaded] = useState(false);
    const [pcImageLoaded, setPCImageLoaded] = useState(false);


  function onCancel() {
    const activeDashboard=activedashboard?.standarddashboardId?.standardName;
    const eventName="CA "+ activeDashboard +" Popup Closed";
    logAmplitudeEvent(amplitude, eventName, {
      clientName: clientname,
      eventTimestamp: new Date().toLocaleString("en-US", { timeZone: "UTC" }),
    });
    userLogsAPI(
      eventName,
      eventName,
      userDetails,
      clientname,
      "Closed",
    );
    dispatch(setCABannerActive(false))
  }

    async function openDashboard() {
      dispatch(setCABannerActive(false))
      const standardName = "Competitor Analysis";
      if (!subscriptions?.length || !standardName) return;
  
      let localProductLine = "";
      let matchedDashboard = null;
  
      for (const subscription of subscriptions) {
        const categories = subscription.productcategoryIds || [];
  
        for (const category of categories) {
          const dashboards = category.dashboardIds || [];
  
          // Find dashboard by standardName instead of ID
          const match = dashboards.find(
            dash => dash.standarddashboardId?.standardName === standardName
          );
  
          if (match) {
            matchedDashboard = match;
            localProductLine = subscription.label;
            break;
          }
        }
  
        if (localProductLine) break; // exit outer loop
      }
      if (!matchedDashboard) {
        console.log(`No dashboard found for standardName: ${standardName}`);
        return;
      }
      const activeDashboard=activedashboard?.standarddashboardId?.standardName;
      const eventName=activeDashboard +" Popup";
      await handleItem({ productLine: localProductLine, clientID: clientID ?? getSession("client_id"), userDetails: userDetails, dashboard: matchedDashboard, clientName: clientname, triggerType: eventName, pathname: location.pathname, dispatch: dispatch, navigate: navigate});
    }

    if(activedashboard?.standarddashboardId?.standardName === "Organization Snapshot")
    return (
        <div
        className="absolute z-[39] w-screen h-screen left-0 right-0 top-0 bottom-0 flex items-center justify-center bg-[#00000080] backdrop-blur-sm"
        >
        <div
            className="relative bg-[#ffffff] overflow-hidden shadow h-max w-[670px] flex"
            onClick={(e) => e.stopPropagation()}
        >
            <div className="absolute w-full h-max z-[160] flex flex-row justify-end items-center p-2">
            <RxCross1 className="cursor-pointer text-textBlack" onClick={openDashboard} />
            </div>
            <div className="w-max h-72 flex flex-col bg-white">
                <div class="w-40 h-full bg-fuchsia-900/30"></div>
                <img src="https://hwlobbystorer1.blob.core.windows.net/icons/CA2.0 icon for OS.svg" className="w-52 absolute top-1/2 transform -translate-y-1/2" alt="CA2.0 icon" />
            </div>
            <div className="flex flex-col w-full mx-10 my-6 h-max">
                <div class="text-left text-primary text-lg font-semibold font-['Roboto'] leading-0 tracking-wide">Competitor Analysis 2.0</div>
                <div class="text-left text-zinc-800 text-md font-semibold font-['Roboto'] mt-3 tracking-wide">Organization Snapshot is now Competitor Snapshot. Access it in Competitor Analysis 2.0</div>
                <div class="w-full text-left mt-4"><span class="text-zinc-800 text-sm font-normal font-['Roboto'] leading-6 tracking-wide">Get a faster, clearer view </span><span class="text-zinc-800 text-sm font-bold font-['Roboto'] leading-6 tracking-wide">with the enhanced Competitor Analysis 2.0 experience.</span></div>
                {/* <div class="w-full text-left text-zinc-800 text-sm font-normal font-['Roboto'] leading-6 tracking-wide">Please use CA 2.0 to access the upgraded experience.</div> */}
                <div class="flex flex-row w-full justify-center gap-4 mt-10">
                    <div class="w-80 h-8 flex items-center justify-center shadow-md bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-[30px] cursor-pointer shadow-black" onClick={openDashboard}>
                        <div class="justify-start text-zinc-800 text-sm font-bold font-['Inter'] uppercase leading-4 tracking-wide">Go to Competitor Analysis 2.0</div>
                    </div>
                    {/* <div class="w-[140px] h-8 flex items-center justify-center rounded-[30px] outline outline-1 outline-offset-[-0.50px] outline-amber-500 cursor-pointer" onClick={onCancel}>
                        <div class="justify-start text-zinc-800 text-sm font-bold font-['Inter'] uppercase leading-4 tracking-wide">Acknowledge</div>
                    </div> */}
                </div>
            </div>
        </div>
        </div>
    );
    // if(activedashboard?.standarddashboardId?.standardName === "Market Snapshot")
    // return (
    //     <div
    //     className="absolute z-[39] w-screen h-screen left-0 right-0 top-0 bottom-0 flex items-center justify-center bg-[#00000080]"
    //     >
    //     <div
    //         className="relative bg-[#ffffff] overflow-hidden shadow h-max w-[970px]"
    //         onClick={(e) => e.stopPropagation()}
    //     >
    //         <div className="absolute w-full h-max z-[160] flex flex-row justify-end items-center p-2">
    //         <RxCross1 className="cursor-pointer text-textBlack" onClick={onCancel} />
    //         </div>
    //         <div className="w-full h-full flex flex-col bg-white items-center">
    //             <div class="flex w-full h-28 bg-fuchsia-900/30 justify-center pt-5">
    //                 <div class="text-center text-primary text-xl font-semibold font-['Roboto'] leading-0 tracking-wide">Competitor Analysis 2.0</div>
    //             </div>
    //             {!msImageLoaded && (
    //                 <div className="w-[900px] h-[320px] -mt-12 rounded-md flex items-center justify-center text-zinc-500 text-sm bg-gray-100">
    //                     Loading preview…
    //                 </div>
    //             )}
    //             <img
    //             src="https://hwlobbystorer1.blob.core.windows.net/icons/CA2.0 ss for MS.png"
    //             className={`w-[900px] shadow-[0_0_24px_rgba(0,0,0,0.25)] -mt-12 rounded-md cursor-pointer ${
    //                 msImageLoaded ? "block" : "hidden"
    //             }`}
    //             alt="Competitor Analysis 2.0 preview"
    //             onClick={openDashboard}
    //             onLoad={() => setMSImageLoaded(true)}
    //             />

    //         </div>
    //         <div className="flex flex-col w-full h-max mt-6 mb-7">
    //             <div class="w-full text-center justify-start text-zinc-800 text-xl font-semibold font-['Roboto'] leading-8 tracking-[0.7px]">Market Snapshot tells you the “what” - CA 2.0 shows you the “why” across competitors.</div>
    //             <div class="w-full justify-start text-zinc-800 text-xl font-normal font-['Roboto'] leading-8 tracking-[1.35px]">Understand competitor drivers, performance shifts, and market movements in one place.</div>
    //             <div class="flex flex-row w-full justify-center gap-4 mt-5">
    //                 <div>
    //                     <div class="w-80 h-8 flex items-center justify-center shadow-md bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-[30px] cursor-pointer shadow-black" onClick={openDashboard}>
    //                         <div class="justify-start text-zinc-800 text-sm font-bold font-['Inter'] uppercase leading-4 tracking-wide">Go to Competitor Analysis 2.0</div>
    //                     </div>
    //                     <div class="text-xs mt-1 text-textBlack text-left ml-2">* Dashboard will open in new tab</div>
    //                 </div>
                    
    //                 <div class="w-[140px] h-8 flex items-center justify-center rounded-[30px] outline outline-1 outline-offset-[-0.50px] outline-amber-500 cursor-pointer" onClick={onCancel}>
    //                     <div class="justify-start text-zinc-800 text-sm font-bold font-['Inter'] uppercase leading-4 tracking-wide">Acknowledge</div>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    //     </div>
    // );
    // if(activedashboard?.standarddashboardId?.standardName === "Enrollment Trends")
    // return (
    //     <div
    //     className="absolute z-[39] w-screen h-screen left-0 right-0 top-0 bottom-0 flex items-center justify-center bg-[#00000080]"
    //     >
    //     <div
    //         className="relative bg-[#ffffff] overflow-hidden shadow h-max w-[970px]"
    //         onClick={(e) => e.stopPropagation()}
    //     >
    //         <div className="absolute w-full h-max z-[160] flex flex-row justify-end items-center p-2">
    //         <RxCross1 className="cursor-pointer text-textBlack" onClick={onCancel} />
    //         </div>
    //         <div className="w-full h-full flex flex-col bg-white items-center">
    //             <div class="flex w-full h-28 bg-fuchsia-900/30 justify-center pt-5">
    //                 <div class="text-center text-primary text-xl font-semibold font-['Roboto'] leading-0 tracking-wide">Competitor Analysis 2.0</div>
    //             </div>
    //             {!etImageLoaded && (
    //                 <div className="w-[900px] h-[320px] -mt-12 rounded-md flex items-center justify-center text-zinc-500 text-sm bg-gray-100">
    //                     Loading preview…
    //                 </div>
    //             )}
    //             <img
    //             src="https://hwlobbystorer1.blob.core.windows.net/icons/CA2.0 ss for ET.png"
    //             className={`w-[900px] shadow-[0_0_24px_rgba(0,0,0,0.25)] -mt-12 rounded-md cursor-pointer ${
    //                 etImageLoaded ? "block" : "hidden"
    //             }`}
    //             alt="Competitor Analysis 2.0 preview"
    //             onClick={openDashboard}
    //             onLoad={() => setETImageLoaded(true)}
    //             />

    //         </div>
    //         <div className="flex flex-col w-full h-max mt-6 mb-9">
    //             <div class="w-full text-center justify-start text-zinc-800 text-xl font-semibold font-['Roboto'] leading-8 tracking-[0.7px]">Not sure what’s causing trend dips or spikes? CA 2.0 brings competitor triggers to light.</div>
    //             {/* <div class="w-full justify-start text-zinc-800 text-xl font-normal font-['Roboto'] leading-8 tracking-[1.35px]">Understand competitor drivers, performance shifts, and market movements in one place.</div> */}
    //             <div class="flex flex-row w-full justify-center gap-4 mt-5">
    //                 <div>
    //                     <div class="w-80 h-8 flex items-center justify-center shadow-md bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-[30px] cursor-pointer shadow-black" onClick={openDashboard}>
    //                         <div class="justify-start text-zinc-800 text-sm font-bold font-['Inter'] uppercase leading-4 tracking-wide">Go to Competitor Analysis 2.0</div>
    //                     </div>
    //                     <div class="text-xs mt-1 text-textBlack text-left ml-2">* Dashboard will open in new tab</div>
    //                 </div>
    //                 <div class="w-[140px] h-8 flex items-center justify-center rounded-[30px] outline outline-1 outline-offset-[-0.50px] outline-amber-500 cursor-pointer" onClick={onCancel}>
    //                     <div class="justify-start text-zinc-800 text-sm font-bold font-['Inter'] uppercase leading-4 tracking-wide">Acknowledge</div>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    //     </div>
    // );
    // if(activedashboard?.standarddashboardId?.standardName === "Plan Comparison")
    // return (
    //     <div
    //     className="absolute z-[39] w-screen h-screen left-0 right-0 top-0 bottom-0 flex items-center justify-center bg-[#00000080]"
    //     >
    //     <div
    //         className="relative bg-[#ffffff] overflow-hidden shadow h-max w-[970px]"
    //         onClick={(e) => e.stopPropagation()}
    //     >
    //         <div className="absolute w-full h-max z-[160] flex flex-row justify-end items-center p-2">
    //         <RxCross1 className="cursor-pointer text-textBlack" onClick={onCancel} />
    //         </div>
    //         <div className="w-full h-full flex flex-col bg-white items-center">
    //             <div class="flex w-full h-28 bg-fuchsia-900/30 justify-center pt-3">
    //                 <div class="text-center text-primary text-xl font-semibold font-['Roboto'] leading-0 tracking-wide">Competitor Analysis 2.0</div>
    //             </div>
    //             {!etImageLoaded && (
    //                 <div className="w-[900px] h-[320px] -mt-16 rounded-md flex items-center justify-center text-zinc-500 text-sm bg-gray-100">
    //                     Loading preview…
    //                 </div>
    //             )}
    //             <img
    //             src="https://hwlobbystorer1.blob.core.windows.net/icons/CA2.0 ss for PC.png"
    //             className={`w-[900px] shadow-[0_0_24px_rgba(0,0,0,0.25)] -mt-16 rounded-md cursor-pointer ${
    //                 etImageLoaded ? "block" : "hidden"
    //             }`}
    //             alt="Competitor Analysis 2.0 preview"
    //             onClick={openDashboard}
    //             onLoad={() => setETImageLoaded(true)}
    //             />

    //         </div>
    //         <div className="flex flex-col w-full h-max mt-2 mb-4">
    //             <div class="w-full text-center justify-start text-zinc-800 text-md font-semibold font-['Roboto'] leading-5 tracking-[0.7px] py-2">In addition to Plan Comparison, CA 2.0 lets you compare up to 5 organizations across grid, chart, and footprint views, track portfolio performance, and see clearer visuals — all at faster speed.</div>
    //             {/* <div class="w-full justify-start text-zinc-800 text-xl font-normal font-['Roboto'] leading-8 tracking-[1.35px]">Understand competitor drivers, performance shifts, and market movements in one place.</div> */}
    //             <div class="flex flex-row w-full justify-center gap-2 mt-2">
    //                 <div class="w-80 h-8 flex items-center justify-center shadow-md bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-[30px] cursor-pointer shadow-black" onClick={openDashboard}>
    //                     <div class="justify-start text-zinc-800 text-sm font-bold font-['Inter'] uppercase leading-4 tracking-wide">Go to Competitor Analysis 2.0</div>
    //                 </div>
    //                 <div class="w-[140px] h-8 flex items-center justify-center rounded-[30px] outline outline-1 outline-offset-[-0.50px] outline-amber-500 cursor-pointer" onClick={onCancel}>
    //                     <div class="justify-start text-zinc-800 text-sm font-bold font-['Inter'] uppercase leading-4 tracking-wide">Acknowledge</div>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    //     </div>
    // );
}

export default memo(NewCABanner);
